'use strict';

angular.module('myConsultApp')
	  .directive('footer', function ($cookieStore, $location, $routeParams, $rootScope) {
	    return {
	      templateUrl: 'templates/footer.html',
	      restrict: 'A',
	     link: function(scope, elem, attr){



			angular.element(document).ready(function () {
				/* Immediately make the mobile/tablet menu background transparent on page load */
				//$('#menuBackground').fadeTo(0,0);

				/* Open any submenu clicked on */

				$('.orgs-dropdown').on('click', 'li.submenu a:first-child', function() {
					var element = $(this).parent();

          $('.orgs-dropdown li.submenu').not(element).removeClass('iconActive');


          $('.orgs-dropdown li.submenu').not(element).find('ul').stop().slideUp(1000,function(){
            $(this).parent().removeClass('activeLite').removeClass('active');
          });

					$(this).parent().toggleClass('iconActive');
					element.find('ul').stop().slideToggle(1000,function(){
						$(this).parent().toggleClass('active');
					});
				});


        $('.navs-dropdown').on('click', 'li.submenu a:first-child', function() {
          var element = $(this).parent();


          $('.navs-dropdown li.submenu').not(element).removeClass('iconActive');

          $('.navs-dropdown li.submenu').not(element).find('ul:first').stop().slideUp(1000,function(){
            $(this).parent().removeClass('activeLite').removeClass('active');
          });

          $(this).parent().toggleClass('iconActive');
          element.find('ul:first').stop().slideToggle(1000,function(){
            $(this).parent().toggleClass('active');
          });

          $('.navs-dropdown > li.innermenu').find('ul').stop().slideUp(0);
        });

        $('.navs-dropdown ul').on('click', 'li.innermenu a:first-child', function (e) {
          e.stopPropagation();

          var element = $(this).parent();

          $('.navs-dropdown > li.innermenu').not(element).find('ul:first').stop().slideToggle(1000,function(){
            $(this).parent().toggleClass('active');
          });

          $(this).parent().toggleClass('iconActive');
          element.find('ul:first').stop().slideToggle(500,function(){
            $(this).parent().removeClass('activeLite').removeClass('active');
          });
        });

				/*$('nav ul li').not('.submenu').find('a').click(function(){
					closeMenu();
				});*/

			});

			/*
			angular.element(document).mouseup(function (e) {
				// Hide the mobile menu if user clicks outside it
				//TODO: This doesn't seem to work in Safari on iPad, which is ok since it's an optional feature
				var container = $('nav');
				if ($(window).width() <= 1024) {
						//Modified by JJ because this was bugging the interface.
						if (!container.is(e.target) && container.has(e.target).length === 0 && container.hasClass('opened')){
							closeMenu();
						}
				}

			});



			angular.element(window).resize(function (e) {

				//Modified by JJ because this was bugging the interface.
				//Reset the mobile menu appropriately when resizing window- mostly for testing

				//change 1024 to 1000
				if ($(window).width() > 1000) {
					openMenu();
				}else{
					closeMenu();
				}

			});
			*/

			/////////END CALLS FROM THE UI KIT JS////////////

	    }
    };
})
.directive('lastPetOwnerRepeat', function() {
        return function(scope, element, attrs) {

			element.click(function(){
				var element2 = $(this).parent();

				$('nav ul li.submenu, .orgs-dropdown li.submenu').not(element2).removeClass('iconActive');

				$('nav ul li.submenu, .orgs-dropdown li.submenu').not(element2).find('ul').stop().slideUp(1000,function(){
					$(this).parent().removeClass('activeLite').removeClass('active');
				});

				$(this).parent().toggleClass('iconActive');
				element2.find('ul').stop().slideToggle(1000,function(){
					$(this).parent().toggleClass('active');
				});
			});
        };
    })
.directive('lastOrgRepeat', function() {
        return function(scope, element, attrs) {
        };
    });
